import { Link } from "react-router-dom";
import { R } from "../resources";

interface FooterProps {
  onContact: (e?: React.MouseEvent) => void;
}

export default function Footer({ onContact }: FooterProps) {
  return (
    <footer>
      <div className="wrap">
        <div className="foot-grid">
          <div>
            <Link className="brand" to="/" style={{ marginBottom: 16 }}>
              <img
                src={R.udLogo}
                alt="Upside Digital"
                style={{ filter: "brightness(0) invert(1)", height: 56 }}
              />
              <span className="brand-word">Upside Digital</span>
            </Link>
            <p style={{ marginTop: 16, maxWidth: "36ch", fontSize: 13.5, lineHeight: 1.6 }}>
              Upside Digital is a digital marketing company specialising in
              pay-per-lead lead generation. Since 2009, we&rsquo;ve delivered
              qualified leads at a fixed cost across insurance, finance, legal,
              e-commerce, energy, home services, business sales, and market
              research. We generate leads across Google, Meta, TikTok, Microsoft,
              and native channels using proprietary technology, data science, and
              AI. Headquartered in Australia, we operate across North America,
              Europe, and Asia Pacific.
            </p>
          </div>
          <div>
            <h5>Site</h5>
            <div className="foot-links">
              <Link to="/solutions">Solutions</Link>
              <Link to="/science">Science</Link>
              <Link to="/verticals">Verticals</Link>
              <Link to="/about-us">About</Link>
              <a href="#" onClick={onContact}>Contact</a>
            </div>
          </div>
          <div>
            <h5>Verticals</h5>
            <div className="foot-links">
              <Link to="/verticals">Insurance</Link>
              <Link to="/verticals">Financing</Link>
              <Link to="/verticals">Legal</Link>
              <Link to="/verticals">E-Commerce</Link>
              <Link to="/verticals">Energy</Link>
              <Link to="/verticals">Home Services</Link>
              <Link to="/verticals">Business Sales</Link>
              <Link to="/verticals">Market Research</Link>
            </div>
          </div>
          <div>
            <h5>Compliance</h5>
            <div className="foot-links">
              <Link to="/privacy-policy-and-disclaimer">Privacy policy</Link>
              <Link to="/terms-conditions">Terms</Link>
            </div>
          </div>
        </div>
        <div className="foot-bottom">
          <span>© 2009–2026 Upside.Digital Pty Ltd</span>
          <span></span>
        </div>
      </div>
    </footer>
  );
}
